import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { tenants, vendors } from 'selectors/entities'
import { transactionEx } from 'selectors/transactions'

import { sortSev } from 'utils/stuff'

const cats = [
	{subtype: "advertising", name: "Advertising", req: "70000 Property Expenses:70010 Advertising"},
	{subtype: "apps", name: "Appliances", req: "70000 Property Expenses:70020 Appliances"},
	{subtype: "cnm", name: "Cleaning and maintenance", req: "70000 Property Expenses:70030 Cleaning and maintenance"},
	{subtype: "hoa", name: "HOA fees", req: "70000 Property Expenses:70040 HOA fees"},
	{subtype: "insurance", name: "Insurance", req: "70000 Property Expenses:70050 Insurance"},
	{subtype: "legal", name: "Legal and Other fees", req: "70000 Property Expenses:70060 Legal and Other fees"},
	{subtype: "management", name: "Management fees", req: "70000 Property Expenses:70070 Management fees"},
	{subtype: "misc", name: "Miscellaneous", req: "70000 Property Expenses:70080 Miscellaneous"},
	{subtype: "loan", name: "Mortgage interest", req: "70000 Property Expenses:70090 Mortgage interest"},
	{subtype: "loan", name: "Mortgage principle", req: "70000 Property Expenses:70100 Mortgage principle"},
	{subtype: "repair", name: "Repair", req: "70000 Property Expenses:70110 Repair"},
	{subtype: "taxes", name: "Taxes", req: "70000 Property Expenses:70120 Taxes"},
	{subtype: "utilities", name: "Utilities", req: "70000 Property Expenses:70130 Utilities"}
]


let select = dirtyRead(
	(state, props) => ({
		object: transactionEx(state, props.objectID)
      , parties: vendors(state)
	  , tenants: tenants(state)
	})
)

export class PropertyCombobox extends Component{
	render(){
		let { props } = this
		return(
			<Combobox
				icon={
					<img
						src="/static/img/svg-icon/tenants_green.svg"
						className="left-navigation-icons"
						style={{
							height: "15px"
							, position: "relative"
							, top: "2px"
							, left: "0px"
							, display: ""
						}}
					/>
				}
				link={`/landlord/tenant/${props.object.partyID}/`}
				key={props.object.partyID}
				exist={(props.object && props.object.partyID)}
				text={props.tenants[props.object.partyID] && (props.tenants[props.object.partyID].tenant || (props.tenants[props.object.partyID].firstName+" "+(props.tenants[props.object.partyID].firstName && props.tenants[props.object.partyID].firstName[0])))}
				hintText={""}
				searchText={props.tenants[props.object.partyID] && (props.tenants[props.object.partyID].tenant || (props.tenants[props.object.partyID].firstName+" "+(props.tenants[props.object.partyID].firstName && props.tenants[props.object.partyID].firstName[0])))}
				dataSource={
					R.map(tenant => ({
						text: `${tenant.firstName}`
					  , value: (
							<MenuItem
								key={tenant._id}
								primaryText={tenant.firstName}
							/>
						)
					  , id: tenant._id
				  }), sortSev(props.tenants, "firstName", "lastName"))
				}
			/>
		)
	}
}

export default connect(select, dataActions)(PropertyCombobox)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/TenantCombobox.js